<template>
	<div class="input-wrapper">
		<input
			type="text"
			:placeholder="placeholder"
			:value="value"
			@input="$emit('input', $event.target.value)"
		/>
		<svg
			class="icon"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<path
				d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
	</div>
</template>

<script>
export default {
	name: "j-search",
	props: {
		value: {
			required: true
		},
		placeholder: {
			type: String
		}
	}
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";

.input-wrapper {
	position: relative;
	width: auto;
}

.input-wrapper > input {
	width: 200px;
	height: 32px;
	padding: var(--spacing2);
	border: 1px solid var(--color7);
	border-radius: var(--borderRadius1);
	outline: 0;
	font-family: var(--fontFamily1);
	font-size: var(--fontSize3);
	line-height: var(--lineHeight100);
}

.input-wrapper > input::placeholder {
	color: var(--color7);
	font-weight: var(--fontWeight7);
}

.input-wrapper > input:focus {
	width: 200px;
	border-color: var(--color2);
	box-shadow: 0 0 4px -1px var(--color2-alpha-90);
}

.input-wrapper > .icon {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	position: absolute;
	top: 0;
	right: 2px;
	height: 100%;
	width: 24px;
	fill: var(--color6);
	cursor: auto;
}
</style>
